import React from "react";
import { WMKLink } from "wmk-lib";
import styled from "styled-components";
import Theme from "../../vars/ThemeOptions";
import {Row, Col} from 'react-bootstrap'

const Styled = {};
Styled.Backlink = styled(WMKLink)`
  margin: 1rem 0 0.5rem 0;
  color: ${Theme.hex("green")};
`;

export const Backlink = ({ to, children }) => {
  return (
    <Styled.Backlink to={to === "//" ? "/" : to}>{children}</Styled.Backlink>
  );
};

export const BackToMain = () => {
  return (
    <Row>
      <Col
        style={{
          padding: "2vh 1vh 4vh 1vh",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Backlink to={"/"}>Back to Main</Backlink>
      </Col>
    </Row>
  );
};
